export default __webpack_public_path__ + "static/image/slider2_1.6553d995.jpg";